import * as React from "react";
import TextField from "@material-ui/core/TextField";

export default function OS() {
  const [state, setState] = React.useState({
    os_type: "",
  });

  const [osname, setosname] = React.useState([[]]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/generics/platform/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setosname(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  return (
    <div>
      <TextField
        type="select"
        id="os_type"
        className="form-control"
        value={state.os_type}
        onChange={handleChange}
        placeholder="-- Select the Profile --"
        variant="outlined"
        size="small"
        select
        SelectProps={{ native: true }}
        fullWidth
      >
        <option>-- Select OS_Type --</option>
        {osname.map((osname) => {
          return (
            <React.Fragment>
              <option value={osname.platform_name}>
                {osname.platform_name}
              </option>
            </React.Fragment>
          );
        })}
      </TextField>
    </div>
  );
}
